import React, { Component } from 'react';
import Glider from 'react-glider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowCircleLeft,
  faArrowCircleRight,
} from '@fortawesome/free-solid-svg-icons';
import withI18next from '~/../hocs/_withI18next';
import I18nLink from '~/components/I18nLink';
import config from '~/config';
import { slugs } from '~/utils';
import themeVariables from '~/shared/themeVariables';
import { SERVICE_TYPES } from '~/utils/constants';

@withI18next()
class SliderSimilar extends Component {
  state = {
    currentSlide: 0,
  };
  gliderRef = React.createRef();

  rendeMainSimilarUrl = (item, lang) => {
    let url = `/${config.detailPagePath[config.serviceType]}/${item.id}`;
    const photoTitle = config.getTitleByLanguage(item.title, lang);

    if (photoTitle) {
      const slugTitle = slugs.makeSlug(photoTitle, { lang });
      url = `${url}/${slugTitle}`;
    }

    return url;
  };

  handleSlideLeft = () => {
    if (this.gliderRef.current && this.state.currentSlide > 0) {
      this.setState(
        {
          currentSlide: this.state.currentSlide - 1,
        },
        () => this.gliderRef.current.scrollItem(this.state.currentSlide, true),
      );
    }
  };

  handleSlideRight = (evt) => {
    evt.stopPropagation();
    if (this.gliderRef.current && this.gliderRef.current.ele) {
      const {
        offsetWidth,
        scrollLeft,
        scrollWidth,
      } = this.gliderRef.current.ele;
      if (offsetWidth + scrollLeft >= scrollWidth) {
        this.setState(
          {
            currentSlide: 0,
          },
          () =>
            this.gliderRef.current.scrollItem(this.state.currentSlide, true),
        );
        return;
      }
      this.setState(
        {
          currentSlide: this.state.currentSlide + 1,
        },
        () => this.gliderRef.current.scrollItem(this.state.currentSlide, true),
      );
    }
  };

  renderSimilarUrl = (domainService, detailPath, item) => {
    const { lng } = this.props;

    let url = '';
    const photoTitle = config.getTitleByLanguage(item.title, lng);

    url = `/${detailPath}/${item.id}`;
    if (photoTitle) {
      const slugTitle = slugs.makeSlug(photoTitle, { lang: lng });
      url = `/${detailPath}/${item.id}/${slugTitle}`;
    }

    return url;
  };

  render() {
    const gliderSettings = {
      className: 'slider-similar-wrapper',
      hasArrows: true,
      skipTrack: true,
      slidesToShow: 1,
      draggable: true,
      iconLeft: (
        <FontAwesomeIcon
          icon={faArrowCircleLeft}
          style={{
            width: 24,
            color: themeVariables.color.darkGray,
            cursor: 'pointer',
            marginLeft: -8,
          }}
          onClick={this.handleSlideLeft}
        />
      ),
      iconRight: (
        <FontAwesomeIcon
          icon={faArrowCircleRight}
          style={{
            width: 24,
            color: themeVariables.color.darkGray,
            cursor: 'pointer',
            marginRight: -8,
          }}
          onClick={this.handleSlideRight}
        />
      ),
    };

    const { images, lng, isMain, domainService, detailPath } = this.props;
    const serviceType = this.props.serviceType || config.serviceType;

    const imageWrapperStyle = {
      width: 'fit-content',
      height: 160,
      overflow: 'hidden',
      display: 'flex',
      margin: '0 4px',
      position: 'relative',
    };
    if (
      serviceType === SERVICE_TYPES.ILLUST_AC ||
      serviceType === SERVICE_TYPES.SILHOUETTE_AC
    ) {
      imageWrapperStyle.background = '#fff';
      imageWrapperStyle.padding = 4;
      imageWrapperStyle.borderRadius = 2;
      imageWrapperStyle.boxShadow = '0 2px 4px 0 rgb(0 0 0 / 20%)';
    }

    return (
      <div className={`similar-image ${config.serviceType}-similar-image`}>
        <Glider ref={this.gliderRef} {...gliderSettings}>
          <div className="placeholder">Placeholder</div>
          {images.map((item) => {
            let width, height;
            width = height = 1000;
            if (item.meta_data) {
              width = item.meta_data.width || 1;
              height = item.meta_data.height || 1;
            }
            const imgHeight = 150;
            const imgWidth = (width * imgHeight) / height;
            const photoTitle = config.getTitleByLanguage(item.title, lng);
            return (
              <figure key={item.id}>
                {isMain ? (
                  <I18nLink
                    prefetch={false}
                    href={this.rendeMainSimilarUrl(item, lng)}
                  >
                    <a>
                      <div style={imageWrapperStyle}>
                        <img
                          className="lazyload slider-similar-image"
                          data-src={item.thumbnail}
                          alt={photoTitle}
                          width={imgWidth}
                          height={imgHeight}
                        />
                        <div className="background-hover-similar"></div>
                      </div>
                    </a>
                  </I18nLink>
                ) : (
                  <I18nLink
                    prefetch={false}
                    host={domainService}
                    href={this.renderSimilarUrl(
                      domainService,
                      detailPath,
                      item,
                      lng,
                    )}
                  >
                    <a target="_blank">
                      <div style={imageWrapperStyle}>
                        <img
                          className="lazyload slider-similar-image"
                          src={item.thumbnail}
                          alt={photoTitle}
                          width={imgWidth}
                          height={imgHeight}
                        />
                        <div className="background-hover-similar"></div>
                      </div>
                    </a>
                  </I18nLink>
                )}
              </figure>
            );
          })}
        </Glider>
        <style jsx>
          {`
            .placeholder {
              display: none;
            }
          `}
        </style>
        <style jsx global>
          {`
            .slider-similar-wrapper {
              display: flex;
              flex-direction: row;
              align-items: center;
              height: 170px;
            }

            .similar-image .glider-next.disabled,
            .similar-image .glider-prev.disabled {
              opacity: 1;
            }

            .lazyload:not([src]) {
              visibility: hidden;
            }
            .background-hover-similar {
              width: 100%;
              height: 100%;
              position: absolute;
              filter: drop-shadow(0px 0px 0px rgba(0, 0, 0, 0.25));
            }
            .background-hover-similar:hover {
              background: linear-gradient(
                  0deg,
                  rgba(0, 0, 0, 0.2),
                  rgba(0, 0, 0, 0.2)
                ),
                url(66121_s.jpg);
            }
          `}
        </style>
      </div>
    );
  }
}

export default SliderSimilar;
